<template>
  <nav aria-label="Shift planner navigation">
    <AppTabs design="new" refined weight="medium" :tabs="tabs" />
  </nav>
</template>

<script>
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'ShiftPlannerNav',
  components: { AppTabs },
  computed: {
    isSupervisor() {
      const roles = this.$store.state.userGroups || []
      return roles.some(role => [
        'general_manager',
        'sales_supervisor',
        'marketing_supervisor'
      ].includes(role.code))
    },
    tabs() {
      const tabs = [{ id: 'month', label: 'My month', name: 'employees-shift-planner' }]
      if (this.isSupervisor) {
        tabs.push({
          id: 'dashboard',
          label: 'Supervisor dashboard',
          name: 'employees-shift-planner-dashboard'
        })
      }
      return tabs
    }
  }
}
</script>
